import * as React from 'react';

import { IComponentBaseConfiguration } from '../models/IComponentBaseConfiguration.js';
import { IComponentBaseProps } from '../models/IComponentBaseProps.js';
import { IComponentBaseState } from '../models/IComponentBaseState.js';
import { ITheme } from '../models/ITheme.js';

import { getSelector } from './selector.js';
import { stripBaseProps } from './stripBaseProps.js';

export abstract class ComponentBase<
	TProps extends IComponentBaseProps,
	TState extends IComponentBaseState,
	TConfiguration extends IComponentBaseConfiguration,
> extends React.Component<TProps, TState> {
	abstract categoryKey: keyof Omit<ITheme, 'fontFaces'>;
	abstract componentKey: string;

	constructor(props: TProps) {
		super(props);
	}

	get parentComponentKey(): string | undefined {
		return undefined;
	}

	get configuration(): TConfiguration | undefined {
		const { configuration } = this.props;
		if (configuration) {
			const category = (configuration as any)[this.categoryKey];
			const parentComponentKey = this.parentComponentKey;
			if (parentComponentKey) {
				const parentConfiguration = (category && category[parentComponentKey]) as IComponentBaseConfiguration;
				if (parentConfiguration && parentConfiguration.childComponents) {
					return parentConfiguration.childComponents[this.componentKey] as TConfiguration;
				}
			} else {
				return (category && category[this.componentKey]) as TConfiguration;
			}
		}
		return;
	}

	get globalConfiguration() {
		const { configuration } = this.props;
		if (configuration) {
			return configuration.global;
		}
	}

	protected get selector() {
		return getSelector(this.categoryKey, this.componentKey);
	}

	protected get componentProps(): Partial<TProps> {
		return stripBaseProps<TProps, Partial<TProps>>(this.props);
	}

	protected appendClassNames(additionalClassNames?: string | string[]) {
		const className = this.props.className || '';
		if (!additionalClassNames || (Array.isArray(additionalClassNames) && additionalClassNames.length <= 0)) {
			return className;
		}
		if (typeof additionalClassNames === 'string') {
			additionalClassNames = [additionalClassNames];
		}
		return `${className} ${additionalClassNames.map((name) => `ksys-${name}`).join(' ')}`;
	}
}
